module.exports = __webpack_public_path__ + "static/skyfloor-a4026d5d12ed6835a4fd5f2647c17f6a.mp4";